export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/sk.lyaml"));
at({ "sk": { "public": { "sampleString": "Vzorov\xFD re\u0165azec" } } });
};